// extracted by mini-css-extract-plugin
module.exports = {"VpcPeerings":"VpcPeerings_GpLvb"};